// VGNA Pro ships no analytics. VGPro called ReactGA from a dozen components;
// this keeps those call sites intact and sends nothing anywhere.
const noop = () => {};
export default {
  initialize: noop, pageview: noop, event: noop, timing: noop, exception: noop,
  set: noop, modalview: noop,
};
